module.exports = __webpack_public_path__ + "static/media/logistica_youtube.ae94af46.png";